/**
 * Calculates speed in meters per seconds
 */
export const calculateSpeed = ({
    timeInSeconds,
    distanceInMeters
}) => {
    if (timeInSeconds === 0) {
        return 0;
    }

    return distanceInMeters / timeInSeconds;
};
